export function applicationFrameConfig({ colors }) {
    return {
        background: colors.background.applicationFrameBackground
    };
}
